import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class HistoryHelperService {
  previousUrl: string;
  isHomeloaded = false;
  isLoaderLoaded = false;
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        console.log("previous URL", this.previousUrl);
        this.previousUrl = urlAfterRedirects;
        if (urlAfterRedirects.indexOf("home") >= 0) {
          this.isHomeloaded = true;
        }
        if (urlAfterRedirects.indexOf("load") >= 0) {
          this.isLoaderLoaded = true;
        }
        console.log("NEW previous URL", this.previousUrl);
      });
  }
}
